import { Component, OnInit } from '@angular/core';
import { Observable, Subscription, forkJoin, retry } from 'rxjs';
import { AllStatusCounts } from 'src/app/core/interfaces/status-counts/all-status-counts';
import { ApiService } from 'src/app/core/services/api/api.service';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { CountsService } from 'src/app/core/services/counts/counts.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { RoleService } from 'src/app/core/services/role/role.service';
import { SyncService } from 'src/app/core/services/sync/sync.service';

@Component({
  selector: 'app-counts',
  templateUrl: './counts.component.html',
  styleUrls: ['./counts.component.scss'],
})
export class CountsComponent implements OnInit {
  currentUserRole: string;
  currentPath: string;

  allCounts: AllStatusCounts;

  countsToDisplay: string[] = [];

  syncStatusSubscription: Subscription;

  constructor(
    private data: DataService,
    private countsService: CountsService,
    private apiService: ApiService,
    private role: RoleService,
    private auth: AuthenticationService,
    private syncService: SyncService
  ) {}

  // TODO: Refactor this so that it will refresh counts after all inits are done.
  ngOnInit(): void {
    this.syncStatusSubscription = this.syncService.currentSyncStatus.subscribe(
      (syncStatus) => {
        if (syncStatus.syncStatus === 'Synced Down') {
          this.getCounts();
        }
      }
    );
    this.getCounts();
  }

  getCounts() {
    this.data.currentPath.subscribe((path) => {
      this.currentPath = path;
      this.countsToDisplay = this.countsService.buildCountsToDisplay(path);

      if (path !== '/auth/login') {
        this.auth.currentAuthStatus.subscribe((authStatus) => {
          if (authStatus) {
            if (this.role.getCurrentOfflineStatus()) {
              const currentRole = this.role.getCurrentUserRole();

              this.countsService.getOfflineCounts(currentRole).subscribe({
                next: (counts) => {
                  this.allCounts = counts;
                },
              });
            } else {
              this.getAllStatusCounts().subscribe({
                next: (counts) => {
                  this.allCounts = counts;
                },
              });
            }
          }
        });
      }
    });
  }

  getAllStatusCounts(): Observable<AllStatusCounts> {
    const allStatusCounts$ = this.apiService
      .getAllStatusCounts()
      .pipe(retry(3));
    return allStatusCounts$;
  }

  ngOnDestroy() {
    this.syncStatusSubscription.unsubscribe();
  }
}
